import React from "react";
import { useTranslation } from "react-i18next";

const Testimonials = ({ slidesRef }) => {
  const { t } = useTranslation();

  return (
    <section id="testimonials" className="testimonials">
      <h2>{t('testimonials.title')}</h2>
      <div className="slider" aria-hidden="true">
        <div className="slides" id="slides" ref={slidesRef}>
          <div className="slide">
            <video controls width="250" style={{ borderRadius: 8 }}>
              <source src="/review1.mp4" type="video/mp4" />
            </video>
            <div style={{ marginTop: 8, fontWeight: 700 }}>Anita R.</div>
            <p
              style={{
                fontSize: 14,
                color: "var(--muted)",
                marginTop: 4,
              }}
            >
              {t('testimonials.reviews.review1')}
            </p>
          </div>

          <div className="slide">
            <video controls width="250" style={{ borderRadius: 8 }}>
              <source src="/review2.mp4" type="video/mp4" />
            </video>
            <div style={{ marginTop: 8, fontWeight: 700 }}>Ramesh K.</div>
            <p
              style={{
                fontSize: 14,
                color: "var(--muted)",
                marginTop: 4,
              }}
            >
              {t('testimonials.reviews.review2')}
            </p>
          </div>

          <div className="slide">
            <video controls width="250" style={{ borderRadius: 8 }}>
              <source src="/review3.mp4" type="video/mp4" />
            </video>
            <div style={{ marginTop: 8, fontWeight: 700 }}>Deepa S.</div>
            <p
              style={{
                fontSize: 14,
                color: "var(--muted)",
                marginTop: 4,
              }}
            >
              {t('testimonials.reviews.review3')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
